import {client} from '@core/GraphQLProvider';
import {NewsletterSignup, OpalescenceSignUp} from './query.graphql';

const NewsletterService = {
    async subscribe ( emailAddress ) {
        const resp = await client.mutate( {
            mutation: NewsletterSignup,
            variables: {emailAddress}
        } );

        return resp.data.newsletterSignup;
    },

    async opalSubscribe ( {input} ) {
        const resp = await client.mutate( {
            mutation: OpalescenceSignUp,
            variables: {input}
        } );

        return resp.data.opalescenceInTheLoopSignup
    }
};

export default NewsletterService;
